import React, { useState, useEffect } from "react";

import axios from "axios";

import { Divider } from "../img";
import { Loading } from "../components";

import "../css/portfolio.css";
const Portfolio = () => {
  let sortBy;
  const [posts, setPosts] = useState([]);
  const [isLoading, setisLoading] = useState(false);

  const API = "https://cdn.contentful.com/spaces/m3b8zyq7g705/environments/master/entries?access_token=COZyZXxv_H2yD1kp3Z7uGWA2W2NOeI6PREkrdxUzOtQ&include=2";

  const fetchPosts = async () => {
    setisLoading(true);

    const response = await axios.get(API);
    const fetchedPosts = response.data;
    const filteredPosts = fetchedPosts.items.filter((post) => post.sys.contentType.sys.id === "portfolioItem");

    const imgIdToImgUrl = (imgId) => {
      const linkedImgs = fetchedPosts.includes.Asset.map((asset) => {
        const id = asset.sys.id;
        const url = asset.fields.file.url;

        return { id, url };
      });

      const img = linkedImgs.filter((img) => img.id === imgId);

      return img[0].url;
    };

    const polishedPosts = filteredPosts.map((post) => {
      const { cover, title, description, engTitle } = post.fields;
      const imgId = cover.sys.id;

      return {
        title,
        engTitle,
        description,
        cover: imgIdToImgUrl(imgId),
      };
    });

    setPosts(polishedPosts);
    setisLoading(false);
  };

  useEffect(() => {
    fetchPosts();
  }, [sortBy]);

  return (
    <div className="portfolio">
      <header>
        <h1>Portfolio</h1>
        <img src={Divider} alt="wavy line" className="divider" />
      </header>

      <main>
        {isLoading ? (
          <Loading />
        ) : (
          <div className="cards">
            {posts.map((post, i) => {
              const { cover, title, description, engTitle } = post;

              return (
                <div className="card" key={i}>
                  <div className="front">
                    <img src={cover} alt="title" />
                  </div>

                  <div className="back">
                    <h1>{title}</h1>
                    <h4>{description}</h4>
                  </div>

                  <div className="left">
                    <h1>{engTitle}</h1>
                  </div>

                  <div className="top"></div>
                </div>
              );
            })}
          </div>
        )}
      </main>
    </div>
  );
};

export default Portfolio;
